import React from 'react';
import GlobalSearch from './GlobalSearch';

const GlobalSearchRouter = (props) => {
  return <GlobalSearch {...props} />;
};

export default GlobalSearchRouter;
